import { useMemo } from "react";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import dayjs from "dayjs";

/**
 * Header
 */

type Props = {
  dataDe: Date | null;
  dataAte: Date | null;
  localLancamento: string | null;
  resistencia: string | null;
  nroNotaFiscal: string | null;
  statusRompimento: number | null;
  enviadoLab: number | null;
  nroLaudo: string | null;
  aprovado: number | null;
  onDataDeChange: (newValue: Date | null) => void;
  onDataAteChange: (newValue: Date | null) => void;
  onLocalLancamentoChange: (newValue: string | null) => void;
  onResistenciaChange: (newValue: string | null) => void;
  onNroNotaFiscalChange: (newValue: string | null) => void;
  onStatusRompimentoChange: (newValue: number | null) => void;
  onEnviadoLabChange: (newValue: number | null) => void;
  onNroLaudoChange: (newValue: string | null) => void;
  onAprovadoChange: (newValue: number | null) => void;
  onClearFilter: () => void;
};

export const Header = ({
  dataDe,
  dataAte,
  localLancamento,
  resistencia,
  nroNotaFiscal,
  statusRompimento,
  enviadoLab,
  nroLaudo,
  aprovado,
  onDataDeChange,
  onDataAteChange,
  onLocalLancamentoChange,
  onResistenciaChange,
  onNroNotaFiscalChange,
  onStatusRompimentoChange,
  onEnviadoLabChange,
  onNroLaudoChange,
  onAprovadoChange,
  onClearFilter,
}: Props) => {
  const statusRompimentoOptions = useMemo(() => {
    return [
      { id: 2, label: 'Todos' },
      { id: 0, label: 'Rompimento em dia' },
      { id: 1, label: 'Rompimento pendente' },
    ];
  }, [
  ]);

  const enviadoLabOptions = useMemo(() => {
    return [
      { id: 2, label: 'Todos' },
      { id: 1, label: 'Sim' },
      { id: 0, label: 'Não' },
    ];
  }, [
  ]);

  const aprovadoOptions = useMemo(() => {
    return [
      { id: 3, label: 'Todos' },
      { id: 1, label: 'Sim' },
      { id: 0, label: 'Não' },
      { id: 2, label: 'Em análise' },
    ];
  }, [
  ]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
          <div className="w-full flex gap-1">
            <DefaultDatePickerInput
              label='De'
              value={dataDe}
              onChange={async (x) => onDataDeChange(x !== null ? dayjs(x).toDate() : null)}
            />

            <DefaultDatePickerInput
              label='Até'
              value={dataAte}
              onChange={async (x) => onDataAteChange(x !== null ? dayjs(x).toDate() : null)}
            />
          </div>

          <DefaultInput
            name='localLancamento'
            label='Local do Lançamento'
            value={localLancamento}
            onChangeValue={x => {
              console.log(x);
              onLocalLancamentoChange(x ?? null);
            }}
          />

          <DefaultInput
            name='resistencia'
            label='Resistência'
            value={resistencia}
            onChangeValue={x => onResistenciaChange(x ?? null)}
          />

          <DefaultInput
            name='nrmNotaFiscal'
            label='Nº da Nota Fiscal'
            value={nroNotaFiscal}
            onChangeValue={x => onNroNotaFiscalChange(x ?? null)}
          />

          <DefaultSelectInput
            name='statusRampimento'
            label='Status do rompimento'
            showSelectionLabel={false}
            options={statusRompimentoOptions}
            value={statusRompimento}
            onChangeValue={x => onStatusRompimentoChange(Number.parseInt(x))}
          />

          <DefaultSelectInput
            name='enviadoLab'
            label='Enviado para laboratório'
            showSelectionLabel={false}
            options={enviadoLabOptions}
            value={enviadoLab}
            onChangeValue={x => onEnviadoLabChange(Number.parseInt(x))}
          />

          <DefaultInput
            name='nroLaudo'
            label='Nº do Laudo'
            value={nroLaudo}
            onChangeValue={x => onNroLaudoChange(x ?? null)}
          />

          <DefaultSelectInput
            name='aprovado'
            label='Aprovado'
            showSelectionLabel={false}
            options={aprovadoOptions}
            value={aprovado}
            onChangeValue={x => onAprovadoChange(Number.parseInt(x))}
          />

        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilter}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}